// extracted by mini-css-extract-plugin
export default {"component":"app-bar-quote-button_component_iSRx5"};